import { ColumnProjection, GetColumnsProps } from './ticketListConfigurations.types';
import {
  ticketNumberAccessor,
  ticketedTimestampAccessor,
  truckAliasAccessor,
  driverNameAccessor,
  customerAccessor,
  addressAccessor,
  loadingPlantAccessor,
  mixDesignProductNumberAccessor,
} from './ticketColumnAccessors';
import { receivedColumn } from '../../../geotrax/incomingMaterials/MaterialReceivedCell';

export default function getColumns(props: GetColumnsProps): ColumnProjection[] {
  const { cellStyle, headerStyle } = props;

  const lastTickets = [
    {
      Header: 'Ticket #',
      id: 'ticketNumber',
      accessor: ticketNumberAccessor,
      style: cellStyle,
      width: 110,
      headerStyle,
    },
    {
      Header: 'Date',
      id: 'ticketedTimestamp',
      accessor: ticketedTimestampAccessor,
      style: cellStyle,
      width: 120,
      headerStyle,
    },
    {
      Header: 'Truck',
      id: 'truckAlias',
      accessor: truckAliasAccessor,
      className: 'vehicle-cell',
      headerClassName: 'vehicle-header',
      width: 155,
      style: cellStyle,
      headerStyle,
    },
    {
      Header: 'Current/ Last Driver',
      id: 'currentDriver',
      accessor: driverNameAccessor,
      className: 'ticket-cell',
      headerClassName: 'ticket-header',
      style: cellStyle,
      width: 200,
      headerStyle,
    },
    {
      Header: 'Customer',
      id: 'customerName',
      accessor: customerAccessor,
      className: 'name-cell',
      headerClassName: 'name-header',
      style: cellStyle,
      width: 200,
      headerStyle,
    },
    {
      Header: 'Delivery Address',
      id: 'address',
      accessor: addressAccessor,
      className: 'address-cell',
      headerClassName: 'address-header',
      width: 250,
      style: cellStyle,
      headerStyle,
    },
    {
      Header: 'Material Source',
      id: 'loadingPlant',
      accessor: loadingPlantAccessor,
      className: 'ticket-cell',
      headerClassName: 'ticket-header',
      style: cellStyle,
      width: 200,
      headerStyle,
    },
    {
      Header: 'Product Number',
      id: 'product',
      accessor: mixDesignProductNumberAccessor,
      className: 'name-cell',
      headerClassName: 'name-header',
      style: cellStyle,
      width: 200,
      headerStyle,
    },
    // DEV-4153: past tickets carry no currentStatus, so the shared cell
    // renders read-only — a checked, locked checkbox for acknowledged
    // tickets, a dash otherwise. Acknowledging is only offered on the
    // current list.
    receivedColumn({ width: 200, cellStyle, headerStyle, hasEditAccess: !!props.hasEditAccess }),
  ];

  return lastTickets;
}
